import { Action } from 'redux';
import { AppState } from 'src';
import { AppDispatcher } from '@models/common.models';
import { requestAction } from '@common/components/common.actions';
import { contractService } from '@services/ContractService';
import { ContractPaymentDetailViewModel } from '@models/Payment';
import { setOrderType } from 'src/contract/contract.actions';

export enum PaymentEditActionType {
  SetPaymentEditLoading = 'SetPaymentEditLoading',
  SetPaymentEditDetail = 'SetPaymentEditDetail'
}

export interface SetPaymentEditLoadingAction extends Action {
  readonly type: PaymentEditActionType.SetPaymentEditLoading;
  readonly isLoading: boolean;
}

export function setPaymentEditLoading(loading: boolean): SetPaymentEditLoadingAction {
  return {
    type: PaymentEditActionType.SetPaymentEditLoading,
    isLoading: loading
  };
}

export interface SetPaymentEditDetailAction extends Action {
  readonly type: PaymentEditActionType.SetPaymentEditDetail;
  readonly paymentEditDetail: ContractPaymentDetailViewModel;
}

export function setPaymentEditDetail(
  contractPaymentDetail: ContractPaymentDetailViewModel
): SetPaymentEditDetailAction {
  // let paymentDetailVM = { ...contractPaymentDetail, creditCardPayment: Object.keys(contractPaymentDetail.creditCardPayment).length > 0 ? contractPaymentDetail.creditCardPayment : undefined };
  return {
    type: PaymentEditActionType.SetPaymentEditDetail,
    paymentEditDetail: contractPaymentDetail // paymentDetailVM
  };
}

export function getContractPaymentDetail(contractId: number) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    return await dispatch(
      requestAction(() => contractService.getPaymentDetail(contractId), setPaymentEditDetail, { hasToast: false })
    );
  };
}

export function setContractOrderSaleType() {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    const paymentEditInfo = getState().contract.paymentEdit.contractPaymentDetail;
    if (paymentEditInfo) {
      dispatch(setOrderType(paymentEditInfo.propertySaleTypeCategoryId));
    }
  };
}

export function convertCreditCardToDemandLetter(contractId: number) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    return await dispatch(
      requestAction(
        () => contractService.creditCardToDemandLetter(contractId),
        () => {
          return { type: '' };
        },
        { hasToast: true, toastSuccessMessage: 'Contract Demand Letter Email Sent Successfully.' }
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/payment-edit/payment-edit.actions.ts